import App from './components/app';
import './index.css';

export default App;
